export function set_action (flags) {
    return {
        type: 'SET_FLAGS',
        data: flags
    }
};